// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","834":"94726e6d"}[chunkId] || chunkId) + "-" + {"245":"09558d1fe5896df7ffee","453":"61dfbf6ce61820c79ed5","577":"88964f9f40328ca9c359","812":"2a723a17ecc762e40cde","822":"dd9ceadf161cb105bb16","834":"250f4688cc74cb22dc7c"}[chunkId] + ".js";
};